const internationalRouter = {
  path: '/international',
  component: () => import('@/layout'),
  children: [
    {
      path: '/member/order/workorderDetail',
      name: 'WorkorderDetail',
      component: () => import(/* webpackChunkName: "misc" */ '@/pages/member/workorderDetail')
    }
  ]
}

export default internationalRouter
